import './Shop.scss'

import React, {Component} from 'react'
import moment from 'moment'
import {connect} from 'react-redux';
import RangeSelector from '../components/RangeSelector';

class SlotsPage extends Component {
    render() {
        const price = 0.0;

        const slots = this.props.slots || [];

        const offer = this.props.offers[this.props.selectedOffer];
        const type = this.props.types[this.props.selectedType]

        return (
            <div className="shop">
                <div className="shop-content">
                    {slots.map((item, i) => (
                    <div key={i }>
                        <h2 className="form-headline">{i+1}. Teilnehmer</h2>
                        <label className="label-grid label-grid--small">
                            <span className="label-text">Vorname*</span>
                            <div className="label-control">
                                <input className="input" type="text" required />
                            </div>
                        </label>  
                        <label className="label-grid label-grid--small">
                            <span className="label-text">Nachname*</span>
                            <div className="label-control">
                                <input className="input" type="text" required />
                            </div>
                        </label>
                        <label className="label-grid">
                            <span className="label-text">Führerscheinklasse*</span>
                            <div className="label-control">
                                <select className="select" required>
                                    <option value="AM">AM</option>
                                    <option value="A1">A1</option>
                                    <option value="A2">A2</option>
                                    <option value="A">A</option>
                                    <option value="B">B/ BF17</option>
                                    <option value="B96">B96</option>
                                    <option value="BE">BE</option>
                                    <option value="C1">C1</option>
                                    <option value="C1E">C1E</option>
                                    <option value="C">C</option>
                                    <option value="CE">CE</option>
                                    <option value="D1">D1</option>
                                    <option value="D1E">D1E</option>
                                    <option value="D">D</option>
                                    <option value="DE">DE</option>
                                    <option value="T">T</option>
                                    <option value="L">L</option>
                                </select>
                            </div>
                        </label>
                    </div>
                    ))}
                    <p className="red">* Pflichtfelder</p> 
                </div>
                <div className="shop-sidebar">
                    <header className="shop-sidebar-header">
                        <h1 className="shop-sidebar-title">Auswahl</h1>
                    </header>
                    <div className="shop-sidebar-content">
                        <div className="offer-order">
                            <h2 className="offer-order-title">{type.title}</h2>
                            <dl className="offer-order-attr-list">
                                <dt className="offer-order-attr-name">Datum:</dt>
                                <dd className="offer-order-attr-value">{offer ? moment(offer.date).format('D. MMMM YYYY') : 'nicht gewählt'}</dd>
                                <dt className="offer-order-attr-name">Beginn:</dt>
                                <dd className="offer-order-attr-value">{offer && offer.begin}</dd>
                                <dt className="offer-order-attr-name">Teilnehmerzahl:</dt>
                                <dd className="offer-order-attr-value">
                                    <RangeSelector 
                                        min={1} 
                                        max={offer && offer.slots||10} 
                                        step={1}
                                        value={this.props.selectedSlots} 
                                        onValueChange={(value) => this.props.onSelectedSlotsChanged(value)}
                                        />
                                </dd>
                            </dl>
                        </div>
                    </div>
                    <footer className="shop-sidebar-footer">
                        <table class="order-table" style={{width: '100%'}}>
                            <tbody>
                                <tr>
                                    <td>Einzelposten</td>
                                    <td style={{textAlign: 'right'}}>0.00 €</td>
                                </tr>
                                <tr>
                                    <th style={{textAlign: 'left'}}>Zwischensumme:</th>
                                    <td style={{textAlign: 'right'}}>{price.toFixed(2)} €</td>
                                </tr>
                            </tbody>
                        </table>
                        <p>
                            <button className="btn" onClick={() => this.props.prev()}>Zurück</button>
                            {offer && (
                            <button className="btn right" onClick={() => this.props.next()} style={{float: 'right'}}>Weiter</button>
                            )}
                        </p>
                    </footer>
                </div>
            </div>
        )
    }
}

const mapStateToProps = state => {
  return {
    ...state.shop,
  }
}

const mapDispatchToProps = dispatch => {
  return {
    onSelectedSlotsChanged: (slots) => dispatch({type: 'SHOP_SELECT_SLOTS', slots: slots})
  }

}

export default connect(
    mapStateToProps, 
    mapDispatchToProps
)(SlotsPage)


// WEBPACK FOOTER //
// ./src/pages/SlotsPage.jsx